"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldPropTypes = exports.fieldOptionsType = exports.fieldOptionGroupsType = exports.checkboxGroupPropTypes = void 0;
exports.fieldPropTypesWithValue = fieldPropTypesWithValue;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *
 * A constant representing the `PropTypes` of the `options` prop for select components, e.g., {@link Select} and {@link CheckboxGroup}
 * 
 * @constant {PropTypes} fieldOptionsType
 * 
 */
var fieldOptionsType = _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].shape({
  key: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
})]));
/**
 *
 * A constant representing the `PropTypes` of the `optionGroups` prop for select components, e.g., {@link Select}
 * 
 * @constant {PropTypes} fieldOptionGroupsType
 * 
 */


exports.fieldOptionsType = fieldOptionsType;

var fieldOptionGroupsType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  name: _propTypes["default"].string.isRequired,
  options: fieldOptionsType.isRequired
}));
/**
 *
 * A function that takes `PropTypes` for a `redux-forms` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object.
 * Returns an object containing all `PropTypes` for `redux-forms` [Field](http://redux-form.com/6.5.0/docs/api/Field.md/) components.
 * 
 * @name fieldPropTypesWithValue
 * @type Function
 * @param {PropTypes} value - `PropTypes` object
 * @returns {Object} `PropTypes` for `redux-forms` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) and [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) objects
 * @example
 * 
 * const valuePropType = PropTypes.string
 * 
 * fieldPropTypesWithValue(valuePropType)
 *
 * // {
 * //   input: PropTypes.shape({
 * //     value: PropTypes.string.isRequired,
 * //     name: PropTypes.string.isRequired,
 * //     onBlur: PropTypes.func,
 * //     onChange: PropTypes.func
 * //   }),
 * //   meta: PropTypes.shape({
 * //     dirty: PropTypes.bool,
 * //     invalid: PropTypes.bool,
 * //     pristine: PropTypes.bool,
 * //     touched: PropTypes.bool,
 * //     valid: PropTypes.bool,
 * //   }).isRequired
 * // }
 *
 */


exports.fieldOptionGroupsType = fieldOptionGroupsType;

function fieldPropTypesWithValue(value) {
  return {
    input: _propTypes["default"].shape({
      value: value.isRequired,
      name: _propTypes["default"].string.isRequired,
      onBlur: _propTypes["default"].func,
      onChange: _propTypes["default"].func
    }),
    meta: _propTypes["default"].shape({
      dirty: _propTypes["default"].bool,
      invalid: _propTypes["default"].bool,
      pristine: _propTypes["default"].bool,
      touched: _propTypes["default"].bool,
      valid: _propTypes["default"].bool
    }).isRequired
  };
}
/** 
 *
 * A constant representing default `PropTypes` for `redux-forms` [Field](http://redux-form.com/6.5.0/docs/api/Field.md/) values.
 * Default types are either `number` or `string`.
 * 
 * @constant {PropTypes} defaultValueTypes
 *
 */


var defaultValueTypes = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]);
/** 
 *
 * An object containing the default `PropTypes` for `redux-forms` [Field](http://redux-form.com/6.5.0/docs/api/Field.md/) components.
 * 
 * @constant {Object} fieldPropTypes
 *
 */


var fieldPropTypes = fieldPropTypesWithValue(defaultValueTypes);
/** 
 *
 * A constant representing the `PropTypes` of the `input` prop for checkbox group components, e.g., {@link CheckboxGroup} and {@link DropdownCheckboxGroup}
 * 
 * @constant {PropTypes} checkboxGroupPropTypes
 *
 */

exports.fieldPropTypes = fieldPropTypes;
var checkboxGroupPropTypes = fieldPropTypesWithValue(_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])));
exports.checkboxGroupPropTypes = checkboxGroupPropTypes;